<template>
  <DialogFactory :value="value" v-on="$listeners">
    <AbstractModalHeader title="Dodaj usługę">
      <template #close>
        <CloseIconButton @click="emitCloseEvent" />
      </template>
    </AbstractModalHeader>
    <v-card-text>
      <div class="service__list">
        <ServiceTaskItem
          v-for="serviceItem in serviceItems"
          :key="serviceItem.serviceType"
          :name="serviceItem.name"
          :isAdded="serviceItem.isAdded"
          @addServiceItem="$emit('selectServiceItem', serviceItem)"
        />
      </div>
    </v-card-text>
  </DialogFactory>
</template>

<script>
import { mapGetters } from 'vuex';
import { SERVICE_TYPE_DICT } from '@/core/dict/service-type-dict';
import DialogFactory from '@/component/Dialog/dialog-factory';
import AbstractModalHeader from '@/component/Dialog/abstract-modal-header';
import CloseIconButton from '@/component/Button/close-icon-button';
import ServiceTaskItem from './service-task-item';

export default {
  name: 'ServiceSelectionModal',
  components: {
    DialogFactory,
    AbstractModalHeader,
    CloseIconButton,
    ServiceTaskItem,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    isCoursePreview: {
      type: Boolean,
      default: false,
    },
    services: Array,
  },
  data() {
    return {
      serviceDetailsModalOpen: false,
      selectedServiceItem: null,
    };
  },
  computed: {
    ...mapGetters('service', [
      'isSupplementingConsumablesAdded',
      'isFleetServiceAdded',
      'isLocomotiveWashingAdded',
      'isLocomotiveReviewP1Added',
      'isLocomotiveReviewP2Added',
      'isLocomotiveReviewP3Added',
      'isTrainCleaningAdded',
      'isCargoCorrectionAdded',
    ]),
    serviceItems() {
      return [
        {
          serviceType: SERVICE_TYPE_DICT.SUPPLEMENTING_MATERIALS,
          name: 'Uzupełnienie materiałów eksploatacyjnych',
          isAdded: this.isCoursePreview
            ? this.services.some(({ serviceType }) => serviceType === SERVICE_TYPE_DICT.SUPPLEMENTING_MATERIALS)
            : this.isSupplementingConsumablesAdded,
        },
        {
          serviceType: SERVICE_TYPE_DICT.FLEET_SERVICE,
          name: 'Serwis taboru',
          isAdded: this.isCoursePreview
            ? this.services.some(({ serviceType }) => serviceType === SERVICE_TYPE_DICT.FLEET_SERVICE)
            : this.isFleetServiceAdded,
        },
        {
          serviceType: SERVICE_TYPE_DICT.LOCOMOTIVE_WASHING,
          name: 'Mycie lokomotywy',
          isAdded: this.isCoursePreview
            ? this.services.some(({ serviceType }) => serviceType === SERVICE_TYPE_DICT.LOCOMOTIVE_WASHING)
            : this.isLocomotiveWashingAdded,
        },
        {
          serviceType: SERVICE_TYPE_DICT.REVIEW_P1,
          name: 'Przegląd lokomotywy (P1)',
          isAdded: this.isCoursePreview
            ? this.services.some(({ serviceType }) => serviceType === SERVICE_TYPE_DICT.REVIEW_P1)
            : this.isLocomotiveReviewP1Added,
        },
        {
          serviceType: SERVICE_TYPE_DICT.REVIEW_P2,
          name: 'Przegląd lokomotywy (P2)',
          isAdded: this.isCoursePreview
            ? this.services.some(({ serviceType }) => serviceType === SERVICE_TYPE_DICT.REVIEW_P2)
            : this.isLocomotiveReviewP2Added,
        },
        {
          serviceType: SERVICE_TYPE_DICT.REVIEW_P3,
          name: 'Przegląd lokomotywy (P3)',
          isAdded: this.isCoursePreview
            ? this.services.some(({ serviceType }) => serviceType === SERVICE_TYPE_DICT.REVIEW_P3)
            : this.isLocomotiveReviewP3Added,
        },
        {
          serviceType: SERVICE_TYPE_DICT.TRAIN_CLEANING,
          name: 'Sprzątanie składu',
          isAdded: this.isCoursePreview
            ? this.services.some(({ serviceType }) => serviceType === SERVICE_TYPE_DICT.TRAIN_CLEANING)
            : this.isTrainCleaningAdded,
        },
        {
          serviceType: SERVICE_TYPE_DICT.CARGO_CORRECTION,
          name: 'Korekta ładunku',
          isAdded: this.isCoursePreview
            ? this.services.some(({ serviceType }) => serviceType === SERVICE_TYPE_DICT.CARGO_CORRECTION)
            : this.isCargoCorrectionAdded,
        },
      ];
    },
  },
  methods: {
    emitCloseEvent() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.service {
  &__list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>
